import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaHeartbeat,
  FaHeart,
  FaBars,
  FaTimes,
} from "react-icons/fa";

function Navbar() {
  const [savedCount, setSavedCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    function updateSavedCount() {
      const saved = JSON.parse(
        localStorage.getItem("zethSavedAssignments") || "[]"
      );

      setSavedCount(saved.length);
    }

    updateSavedCount();

    window.addEventListener("storage", updateSavedCount);
    window.addEventListener("zeth-saved-jobs-updated", updateSavedCount);

    return () => {
      window.removeEventListener("storage", updateSavedCount);
      window.removeEventListener(
        "zeth-saved-jobs-updated",
        updateSavedCount
      );
    };
  }, []);

  function closeNavigation() {
    setMenuOpen(false);
    setActiveDropdown(null);
  }

  function toggleDropdown(name) {
    setActiveDropdown((current) =>
      current === name ? null : name
    );
  }

  return (
    <header className="main-header">
      <Link className="brand" to="/" onClick={closeNavigation}>
        <div className="logo-symbol">
          <FaHeartbeat />
        </div>

        <div className="brand-text">
          <strong>ZETH</strong>
          <span>HEALTH</span>
          <small>STAFFING INC.</small>
        </div>
      </Link>

      <button
        className="mobile-menu-button"
        type="button"
        onClick={() => {
          setMenuOpen((current) => !current);
          setActiveDropdown(null);
        }}
        aria-label="Toggle navigation menu"
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      <nav className={`main-nav ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={closeNavigation}>
          Home
        </Link>

        <a href="/#assignments" onClick={closeNavigation}>
          Assignments
        </a>

        <Link to="/news" onClick={closeNavigation}>
          Healthcare Hub
        </Link>

        <Link
          to="/saved-jobs"
          className="saved-nav"
          onClick={closeNavigation}
        >
          <FaHeart />
          <span>Saved Jobs</span>

          {savedCount > 0 && (
            <strong className="saved-count">{savedCount}</strong>
          )}
        </Link>

        <div className="nav-dropdown">
          <button
            className="dropdown-trigger"
            type="button"
            onClick={() => toggleDropdown("professionals")}
          >
            Professionals <span>▾</span>
          </button>

          <div
            className={`dropdown-menu ${
              activeDropdown === "professionals" ? "show" : ""
            }`}
          >
            <Link to="/professional/login" onClick={closeNavigation}>
              Login
            </Link>

            <Link to="/professional/register" onClick={closeNavigation}>
              Register
            </Link>

            <a href="/#assignments" onClick={closeNavigation}>
              Browse Assignments
            </a>

            <a href="/#professionals" onClick={closeNavigation}>
              Why Join Zeth
            </a>
          </div>
        </div>

        <div className="nav-dropdown">
          <button
            className="dropdown-trigger"
            type="button"
            onClick={() => toggleDropdown("facilities")}
          >
            Facilities <span>▾</span>
          </button>

          <div
            className={`dropdown-menu ${
              activeDropdown === "facilities" ? "show" : ""
            }`}
          >
            <Link to="/facility/login" onClick={closeNavigation}>
              Login
            </Link>

            <Link to="/facility/register" onClick={closeNavigation}>
              Register
            </Link>

            <a href="/#facilities" onClick={closeNavigation}>
              Request Staff
            </a>

            <a href="/#solutions" onClick={closeNavigation}>
              Staffing Solutions
            </a>
          </div>
        </div>

        <a href="/#about" onClick={closeNavigation}>
  About
</a>

<Link
  to="/admin/login"
  onClick={closeNavigation}
>
  Admin Portal
</Link>

<a href="/#contact" onClick={closeNavigation}>
  Contact
</a>
      </nav>

      <div className="header-actions">
        <Link className="login-button" to="/professional/login">
          Login
        </Link>

        <Link className="apply-button" to="/professional/register">
          Apply Now
        </Link>
      </div>
    </header>
  );
}

export default Navbar;